import { Builder } from '@builder.io/react';

import DocumentIndustries from './index';

Builder.registerComponent(DocumentIndustries, {
  name: 'DocumentIndustries',
  inputs: [
    {
      name: 'product',
      type: 'string'
    },
    {
      name: 'productType',
      type: 'string',
      enum: ['threeDSensorFusion', 'image', 'text', 'document', 'video', 'mapping'],
      defaultValue: ['document']
    }
  ]
});
